import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../properties/endpoints';

@Injectable({
  providedIn: 'root'
})
export class RefreshForecastUploadService {
  constructor(private http: HttpClient) { }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('input_file', file, file.name);
    return this.http.post(`${api.host}/ai-assistant/refresh-forecast-numbers`, formData);
  }
}
